import axios from "axios";

export const ENV = process.env;

export const ALLOWED_IMAGE_EXTENSIONS = ENV.REACT_APP_ALLOWED_IMAGE_EXTENSIONS.split(",");

export const AXIOS_BASE_BACKEND = axios.create({
  baseURL: ENV.REACT_APP_BACKEND_BASE_URL
});

export const AXIOS_UPLOAD_SERVER = axios.create({
  baseURL: ENV.REACT_APP_UPLOAD_SERVER_URL
});